import "jquery-ui/ui/widget";
import "blueimp-file-upload";
import * as $ from "jquery";

window.jQuery = window.$ = $;
